import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { tr } from "../contexts/LangContext";

export default function StaffRoute({ allowed, children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-navy text-sm tracking-widest uppercase" data-testid="staff-loading">{tr("Chargement…")}</div>;
  }
  if (user === false) return <Navigate to="/login" replace />;
  const myRoles = new Set([user.role, ...(user.roles || [])].filter(Boolean));
  const hasAccess = allowed.some((r) => myRoles.has(r));
  if (!hasAccess) return <Navigate to="/dashboard" replace />;
  return children;
}
